const DEFAULT_TYPE = "--";
const NULL_UNDIFINED = ["[object Undefined]", "[object Null]"];
function formatData(data, formatType = DEFAULT_TYPE) {
  if (data !== 0 && data !== "0" && !data) {
    return formatType;
  }
  if (Object.prototype.toString.call(data) === "[object Array]") {
    return formatArray(data, formatType);
  }
  if (Object.prototype.toString.call(data) === "[object Object]") {
    return formatObject(data, formatType);
  }
}
function formatObject(data, formatType = DEFAULT_TYPE) {
  const keys = Object.keys(data);
  for (const key of keys) {
    if (typeof data[key] === "string" && data[key] === "" || NULL_UNDIFINED.includes(Object.prototype.toString.call(data[key]))) {
      data[key] = formatType;
    }
  }
  return data;
}
function formatArray(data, formatType = DEFAULT_TYPE) {
  return data.map((item) => formatObject(item, formatType));
}
const EmptyUtils = {
  DEFAULT_TYPE,
  formatData,
  formatObject,
  formatArray
};
export { EmptyUtils };
